"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontStyles = void 0;
// eslint-disable-next-line no-undef
var isNative = navigator.product === 'ReactNative';
var getFontStyles = function (fontName, isNativeIOS, bold) {
    if (!isNative) {
        return fontName;
    }
    var styles = "font-family: ".concat(fontName, ";\n  ");
    if (bold && isNativeIOS) {
        styles += "font-weight: bold;\n    ";
    }
    return styles;
};
exports.getFontStyles = getFontStyles;
